module.exports = __webpack_public_path__ + "static/img/8.74b77ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/8.png
// module id = Nd1W
// module chunks = 0